<script setup lang="ts">
import { computed } from 'vue';
import type { TranslationProvider } from '@sky-lingo-v2/shared';

const props = defineProps<{ provider: TranslationProvider }>();

const files: Record<TranslationProvider, string> = {
  google: 'google-translate.svg',
  deepl: 'deepl.svg',
  hunyuan: 'hunyuan.svg',
  qwen: 'qwen.svg',
  ai: 'alibaba-cloud.png',
  aai: 'tencent-cloud.png',
  index35b: 'index-translate.png',
  bing: 'bing-translator.svg',
  index2b: 'index-translate.png',
};

const baseUrl = import.meta.env.BASE_URL;
const logoUrl = computed(() =>
  `${baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`}assets/providers/${files[props.provider]}`,
);
</script>

<template>
  <img
    class="provider-logo"
    :class="{ 'provider-logo-deepl': provider === 'deepl' }"
    :src="logoUrl"
    alt=""
    aria-hidden="true"
    width="32"
    height="32"
    decoding="async"
  />
</template>

<style scoped>
.provider-logo {
  display: block;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  object-fit: contain;
}
.provider-logo-deepl { padding: 2px; border-radius: 4px; background: #eef5ff; }
</style>
